var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-10-01
 * @brief EHP Check Sheet 관리 개발
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../../recoil/userState";
import { loadingBoxState } from "../../../../recoil/menuState";
import { langState } from '../../../../recoil/langState';
// utils
import clog from "../../../../utils/logUtils";
import * as CONST from "../../../../utils/Const";
import * as CUTIL from "../../../../utils/commUtils";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
/**
 * @brief EHP Check Sheet - List 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
//component
import EhpPagination from "../../../common/pagination/EhpPagination";
function SpgCheckNewList(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    const [langs, setRecoilLangs] = useRecoilState(langState); // recoil langState
    //props
    const isMobile = props.isMobile;
    const adminType = props.adminType;
    const setParentAdminType = props.setAdminType;
    const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    const workMode = props.workMode;
    const setParentWorkMode = props.setWorkMode;
    const setParentPopWin = props.setPopWin;
    //
    //const pageInfo = props.pageInfo;
    //const setParentPageInfo = props.setPageInfo;
    //const versionList = props.versionList;
    //const spgVersion = props.spgVersion;
    //const setParentSpgVersion = props.setSpgVersion;
    //화면 이동
    const navigate = useNavigate();
    //
    const stepList = [
        { "stepName": "전체", "stepVal": "" },
        { "stepName": "Basic", "stepVal": "BASIC" },
        { "stepName": "Premium", "stepVal": "PREMIUM" },
        { "stepName": "Advanced", "stepVal": "ADVANCED" },
    ];
    const [selStep, setSelStep] = useState(stepList[0]);
    useEffect(() => {
        setSelStep(stepList[0]);
        setPageInfo(defaultPageInfo);
    }, [selTree]);
    //const [versionList, setVersionList] = useState(null);
    const [versionReload, setVersionReload] = useState(false);
    const [spgNewVersion, setSpgNewVersion] = useState(null);
    const [checkList, setCheckList] = useState([]);
    const defaultPageInfo = { "size": 10, "totalElements": 0, "totalPages": 0, "number": 0, "psize": 10, "listReload": false };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleListReload(val, page) {
        if (page > -1) {
            setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page, listReload: true }));
        }
        else {
            setPageInfo(Object.assign(Object.assign({}, pageInfo), { listReload: true }));
        }
    }
    ///////////
    const [errorList, setErrorList] = useState([]);
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "POST",
        appPath: `/api/v2/checksheet/step/spg/${selTree.spg.spgName}/items`,
        appQuery: {
            spgName: selTree.spg.spgName,
        },
        userToken: userInfo.loginInfo.token,
        watch: selTree
    });
    /*{"versionNo":"3.0","spgName":"배전반","enabled":false,"completed":false,"editing":true}*/
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
        if (ERR_URL.length > 0) {
            setRecoilIsLoadingBox(false);
            navigate(ERR_URL);
        }
        if (retData) {
            clog("IN CHECK SHEET LIST : NEW VERSION : RES : " + JSON.stringify(retData.body));
            setRecoilIsLoadingBox(false);
            if (retData.codeNum === CONST.API_200) {
                if (retData.body.editing) {
                    alert(`수정 진행중인 버전이 존재합니다.\n수정 중 버전 ${retData.body.spgName} ${retData.body.versionNo}`);
                }
                else {
                    alert(`신규 버전을 추가하여 편집화면으로 이동합니다.\n기존 버전 ${retData.body.spgName} ${retData.body.preVersionNo}\n신규 버전 ${retData.body.spgName} ${retData.body.versionNo}`);
                }
                setInsertCount(0);
                setSpgNewVersion(retData.body);
            }
        }
    }, [selTree, retData]);
    function selectOptionStep(optionElement) {
        const selectBox = optionElement.closest(".select");
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        var optionData = optionElement.getAttribute("data-value");
        selectedElement.setAttribute("data-value", optionData);
        //
        setSelStep(JSON.parse(optionData));
        // params init
        if (selStep.stepVal !== JSON.parse(optionData).stepVal)
            setPageInfo(defaultPageInfo);
    }
    const [insertCount, setInsertCount] = useState(0);
    function onClicInsertSpgCheck(e) {
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-spgcheck-add");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "797");
        //CUTIL.jsclose_Popup("pop-spgcheck-detail");    
        //setParentWorkMode("UPDATE");
        setParentPopWin("pop-spgcheck-add", React.createElement(PopupSpgCheckInsert, { htmlHeader: React.createElement("h1", null, "e-HC Check Sheet \uAD00\uB9AC"), spgInfo: spgNewVersion, setListReload: handleListReload, insertCount: insertCount + 1, setInsertCount: setInsertCount }));
        CUTIL.jsopen_Popup(e);
    }
    function onClickSpgVersionComplete(e) {
        return __awaiter(this, void 0, void 0, function* () {
            var isOk = confirm(`버전 작업을 완료하시겠습니까?\n버전 작업 완료 시 신규 버전으로 업데이트되며 동일 버전으로\n수정 및 삭제가 불가능합니다.`);
            if (!isOk)
                return;
            let data = null;
            //setRecoilIsLoadingBox(true);
            //CUTIL.sleep(500);
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "PUT",
                "appPath": `/api/v2/checksheet/spg/version/complete?versionNo=${spgNewVersion.versionNo}&spgName=${spgNewVersion.spgName}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                //setRecoilIsLoadingBox(false);
                if (data.codeNum == CONST.API_200) {
                    clog(JSON.stringify(data.body));
                    setParentWorkMode("LIST");
                    setParentSelTree(adminType, Object.assign(Object.assign({}, selTree), { reload: true }));
                    alert(JSON.stringify(data.body));
                }
                else {
                    alert(data.body.errorList[0].msg);
                }
            }
        });
    }
    clog("IN CHECK NEW LIST TEMP : INIT : " + workMode);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__right_content workplace__info workplace__main info__input newtype" },
            React.createElement("div", { className: "page-top" },
                React.createElement("h2", null,
                    selTree.spg.spgName,
                    " ",
                    (spgNewVersion) && spgNewVersion.versionNo,
                    React.createElement("span", { className: "txt-info" },
                        React.createElement("span", { className: "point" }, "\uC218\uC815 \uC911"),
                        " *\uC6B0\uCE21 [\uC791\uC5C5\uC644\uB8CC] \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uC5EC \uC218\uC815/\uCD94\uAC00 \uC791\uC5C5\uC744 \uC644\uB8CC\uD574\uC8FC\uC138\uC694."))),
            React.createElement("div", { className: "tbl__top mb-16" },
                React.createElement("div", { className: "left" },
                    React.createElement("div", { className: "searcharea" },
                        React.createElement("div", { className: "searchinput" },
                            React.createElement("span", { className: "mr-16" },
                                React.createElement("strong", null, "\uC810\uAC80\uB2E8\uACC4")),
                            React.createElement("div", { className: "select w186", onClick: (e) => CUTIL.onClickSelect(e, selectOptionStep) },
                                React.createElement("div", { className: "selected" },
                                    React.createElement("div", { className: "selected-value" }, selStep.stepName),
                                    React.createElement("div", { className: "arrow" })),
                                React.createElement("ul", null, stepList.map((step, idx) => (React.createElement("li", { key: `st_${idx.toString()}`, className: "option", "data-value": JSON.stringify(step) }, step.stepName)))))))),
                React.createElement("div", { className: "right" },
                    React.createElement("button", { type: "button", className: "bg-gray", "data-pop": "pop-spgcheck-add", onClick: (e) => onClicInsertSpgCheck(e) },
                        React.createElement("span", null, "\uD56D\uBAA9 \uCD94\uAC00")),
                    React.createElement("button", { type: "button", className: "bg-blue ml-7 js-open", "data-pop": "pop-version", onClick: (e) => onClickSpgVersionComplete(e) },
                        React.createElement("span", null, "\uC791\uC5C5 \uC644\uB8CC")))),
            (spgNewVersion) && /*(checkList.length > 0)&&*/
                React.createElement(CheckList, { adminType: props.adminType, selTree: selTree, selStep: selStep, spgNewVersion: spgNewVersion, checkList: checkList, setCheckList: setCheckList, pageInfo: pageInfo, setPageInfo: setPageInfo, workMode: props.workMode, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin }))));
}
;
export default SpgCheckNewList;
function CheckList(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    const [langs, setRecoilLangs] = useRecoilState(langState); // recoil langState
    //props
    const selStep = props.selStep;
    const spgNewVersion = props.spgNewVersion;
    const checkList = props.checkList;
    const setParentCheckList = props.setCheckList;
    const pageInfo = props.pageInfo;
    const setParentPageInfo = props.setPageInfo;
    //
    const isMobile = props.isMobile;
    const adminType = props.adminType;
    const setParentAdminType = props.setAdminType;
    const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    //const workMode = props.workMode;
    //const setParentWorkMode = props.setWorkMode;
    const setParentPopWin = props.setPopWin;
    //화면 이동
    const navigate = useNavigate();
    //
    const [workMode, setWorkMode] = useState("LIST");
    function handleCurPage(page) {
        setParentPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    function handleListReload(val, page) {
        if (page > -1) {
            setParentPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page, listReload: true }));
        }
        else {
            setParentPageInfo(Object.assign(Object.assign({}, pageInfo), { listReload: true }));
        }
    }
    //////////////////
    let appPath = "";
    appPath = 'page=' + pageInfo.number + '&size=' + pageInfo.size;
    appPath = appPath + `&spgName=${selTree.spg.spgName}`;
    if (spgNewVersion) {
        appPath = appPath + "&versionNo=" + spgNewVersion.versionNo;
    }
    if (selStep.stepVal.length > 0) {
        appPath = appPath + "&stepName=" + selStep.stepVal;
    }
    appPath = appPath + `&language=${CUTIL.apiLangSet(langs)}`;
    const [errorList, setErrorList] = useState([]);
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/checksheet/step/spg/items/admin?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: selTree + appPath + spgNewVersion + pageInfo.listReload
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        /*const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
        if (ERR_URL.length > 0) {
          setRecoilIsLoadingBox(false);
          navigate(ERR_URL);
        }*/
        if (retData) {
            setRecoilIsLoadingBox(false);
            if (retData.codeNum == CONST.API_200) {
                setParentCheckList(retData.body);
                setParentPageInfo(Object.assign(Object.assign({}, retData.data.page), { psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT })); //5, 10
                setWorkMode("LIST");
            }
        }
    }, [selTree, retData]);
    function onClickDeleteSpgCheck(e, checkInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            var isOk = confirm(`해당 항목를 삭제하시겠습니까?`);
            if (!isOk)
                return;
            let data = null;
            setRecoilIsLoadingBox(true);
            //CUTIL.sleep(500);
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "DELETE",
                "appPath": `/api/v2/checksheet/step/spg/item`,
                appQuery: {
                    "code": checkInfo.code,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                setRecoilIsLoadingBox(false);
                if (data.codeNum == CONST.API_200) {
                    handleListReload(true, 0);
                    //alert(`정상적으로 삭제되었습니다.`);
                }
                else {
                    alert(data.body.errorList[0].msg);
                }
            }
        });
    }
    function onClickViewSpgCheck(e, checkInfo) {
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-spgcheck-detail");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "797");
        //setWorkMode("READ");
        setParentPopWin("pop-spgcheck-detail", //pop-spgcheck-detail
        React.createElement(PopupSpgCheckView, { htmlHeader: React.createElement("h1", null, "e-HC Check Sheet \uAD00\uB9AC"), checkInfo: checkInfo, setListReload: handleListReload, workMode: workMode, setWorkMode: setWorkMode, setPopWin: props.setPopWin }));
        CUTIL.jsopen_Popup(e);
    }
    //clog("IN CHECK LIST COMP : INIT : " + workMode);
    clog("SPG CHECK LIST : INIT : " + workMode);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "tbl-list checksheet-list" },
            React.createElement("table", { summary: "\uC810\uAC80\uB2E8\uACC4,\uCF54\uB4DC,\uADF8\uB8F9,\uC774\uB984,\uC124\uBA85,\uAC00\uC911\uCE58 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C ACB \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." },
                React.createElement("caption", null, "ACB \uB9AC\uC2A4\uD2B8"),
                React.createElement("colgroup", null,
                    React.createElement("col", { style: { "width": "9%" } }),
                    React.createElement("col", { style: { "width": "14%" } }),
                    React.createElement("col", { style: { "width": "12%" } }),
                    React.createElement("col", { style: { "width": "22%" } }),
                    React.createElement("col", { style: { "width": "25%" } }),
                    React.createElement("col", { style: { "width": "8%" } }),
                    React.createElement("col", { style: { "width": "5%" } }),
                    React.createElement("col", { style: { "width": "5%" } })),
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", { scope: "col", className: "txt-left" }, "\uC810\uAC80\uB2E8\uACC4"),
                        React.createElement("th", { scope: "col", className: "txt-left" }, "\uCF54\uB4DC"),
                        React.createElement("th", { scope: "col", className: "txt-left" }, "\uADF8\uB8F9"),
                        React.createElement("th", { scope: "col", className: "txt-left" }, "\uC774\uB984"),
                        React.createElement("th", { scope: "col", className: "txt-left" }, "\uC124\uBA85"),
                        React.createElement("th", { scope: "col", className: "txt-left" }, "\uAC00\uC911\uCE58"),
                        React.createElement("th", { scope: "col" },
                            React.createElement("span", { className: "hide" }, "\uC0C1\uC138\uBCF4\uAE30")),
                        React.createElement("th", { scope: "col" }, "\uC0AD\uC81C"))),
                React.createElement("tbody", null,
                    (!spgNewVersion) &&
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 8, className: "" },
                                React.createElement("strong", { className: "txt-purple" }, "Version\uC744 \uC120\uD0DD\uD558\uC138\uC694."))),
                    checkList.map((check, idx) => (React.createElement("tr", { key: `sh_${idx.toString()}` },
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-spgcheck-detail", onClick: (e) => onClickViewSpgCheck(e, check) },
                            React.createElement("strong", { className: "txt-purple" }, check.checkStepDto.name)),
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-spgcheck-detail", onClick: (e) => onClickViewSpgCheck(e, check) }, check.code),
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-spgcheck-detail", onClick: (e) => onClickViewSpgCheck(e, check) }, check.checkGroupDto.groupName),
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-spgcheck-detail", onClick: (e) => onClickViewSpgCheck(e, check) }, check.name),
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-spgcheck-detail", onClick: (e) => onClickViewSpgCheck(e, check) }, check.description),
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-spgcheck-detail", onClick: (e) => onClickViewSpgCheck(e, check) },
                            React.createElement("strong", null, check.weight)),
                        React.createElement("td", { className: "js-open", "data-pop": "pop-spgcheck-detail" },
                            React.createElement("button", { type: "button", className: "btn-more", onClick: (e) => onClickViewSpgCheck(e, check) },
                                React.createElement("span", { className: "hide" }, "\uC0C1\uC138\uBCF4\uAE30"))),
                        React.createElement("td", null,
                            React.createElement("button", { type: "button", className: "btn btn-delete-gr js-open", "data-pop": "pop-delete", onClick: (e) => onClickDeleteSpgCheck(e, check) },
                                React.createElement("span", { className: "hide" }, "\uD56D\uBAA9 \uC0AD\uC81C"))))))))),
        React.createElement(EhpPagination, { componentName: "HTTPMESSAGELIST", pageInfo: pageInfo, handleFunc: handleCurPage })));
}
;
// SPG 체크 항목 조회 
function PopupSpgCheckView(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props
    const checkInfo = props.checkInfo;
    const workMode = props.workMode;
    const setParentWorkMode = props.setWorkMode;
    const setParentPopWin = props.setPopWin;
    const setParentListReload = props.setListReload;
    //
    const [spgCheckItem, setSpgCheckItem] = useState(null);
    const [updateCount, setUpdateCount] = useState(0);
    const defaultRefDtoList = [
        { "score": 0, "reference": "" },
        { "score": 1, "reference": "" },
        { "score": 2, "reference": "" },
        { "score": 3, "reference": "" },
        { "score": 4, "reference": "" },
    ];
    clog("SPG CHECK VIEW : INIT : " + workMode + " : " + JSON.stringify(checkInfo));
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/checksheet/step/spg/item?code=${checkInfo.code}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: checkInfo.code + workMode + updateCount
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        if (retData) {
            setRecoilIsLoadingBox(false);
            clog("IN SPGCHECK VIEW : RES : " + JSON.stringify(retData.body));
            if (retData.codeNum == CONST.API_200) {
                retData.body.map((fcheck) => {
                    if (CUTIL.isnull(fcheck.checkItemRefDtoList))
                        fcheck.checkItemRefDtoList = defaultRefDtoList;
                });
                setSelLang(CONST.STR_APILANG_KOR);
                setSpgCheckItem(retData.body);
                //setParentWorkMode("READ");
                setUpdateCount(0);
            }
        }
    }, [retData]);
    function onClickUpdateSpgCheck(e, check) {
        clog("UPDE : CHEKC : " + JSON.stringify(spgCheckItem));
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-spgcheck-edit");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "797");
        CUTIL.jsclose_Popup("pop-spgcheck-detail");
        //setParentWorkMode("UPDATE");
        setParentPopWin("pop-spgcheck-edit", React.createElement(PopupSpgCheckUpdate, { htmlHeader: React.createElement("h1", null, "e-HC Check Sheet \uAD00\uB9AC"), checkInfo: check, spgCheckItem: spgCheckItem, setListReload: props.setListReload, workMode: props.workMode, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin, updateCount: updateCount + 1, setUpdateCount: setUpdateCount }));
        CUTIL.jsopen_Popup(e);
    }
    function onClickCancel(e) {
        //setParentListReload(true);
        setParentWorkMode("LIST");
        CUTIL.jsclose_Popup("pop-spgcheck-detail");
        setParentPopWin("pop-spgcheck-detail", null);
    }
    const [selLang, setSelLang] = useState(CONST.STR_APILANG_KOR);
    const langSet = [
        { "tabId": 0, "tabTxt": "한국어", "tabVal": CONST.STR_APILANG_KOR },
        { "tabId": 1, "tabTxt": "English", "tabVal": CONST.STR_APILANG_ENG },
        { "tabId": 2, "tabTxt": "中文", "tabVal": CONST.STR_APILANG_CHA },
    ];
    useEffect(() => {
        setSelLang(CONST.STR_APILANG_KOR);
    }, []);
    function onClickLangTab(e) {
        var actTag = (e.target.tagName === "LI") ? e.target : e.currentTarget;
        var tabStrInfo = actTag.getAttribute("data-value");
        var tabInfo = JSON.parse(tabStrInfo);
        setSelLang(tabInfo.tabVal);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            (spgCheckItem) && spgCheckItem.filter(citem => citem.language === selLang).map((checkItem, idx) => (React.createElement(React.Fragment, { key: `rfr_${idx.toString()}` },
                React.createElement("ul", { className: "form__input" },
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC810\uAC80\uB2E8\uACC4"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", value: (checkItem.language === selLang) ? checkItem.checkStepDto.name : "", disabled: true }))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uAE30\uAE30 \uBA85"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", value: (checkItem.language === selLang) ? checkItem.spgDto.name : "", disabled: true }))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uADF8\uB8F9 \uBA85"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", value: (checkItem.language === selLang) ? checkItem.checkGroupDto.groupName : "", disabled: true })))),
                React.createElement("ul", { className: "tab__small" }, langSet.map((tlang, idx) => (React.createElement("li", { key: `tli_${idx.toString()}`, className: (tlang.tabVal === selLang) ? "on" : "", onClick: (e) => onClickLangTab(e), "data-value": JSON.stringify(tlang) },
                    React.createElement("a", null, tlang.tabTxt))))),
                React.createElement("ul", { className: "form__input" },
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC774\uB984"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", value: (checkItem.language === selLang) ? (!CUTIL.isnull(checkItem.checkItemName)) ? checkItem.checkItemName : "" : "", disabled: true }))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC124\uBA85"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", value: (checkItem.language === selLang) ? (!CUTIL.isnull(checkItem.description)) ? checkItem.description : "" : "", disabled: true }))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uAC00\uC911\uCE58"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", value: (checkItem.language === selLang) ? (!CUTIL.isnull(checkItem.weight)) ? checkItem.weight : "" : "", disabled: true }))))))),
            React.createElement("div", { className: "tbl-list" },
                React.createElement("table", { summary: "\uC810\uC218, \uD3C9\uAC00\uAE30\uC900 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uD310\uC815 List \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "\uD310\uC815 List"),
                    React.createElement("colgroup", null,
                        React.createElement("col", { style: { "width": "16%" } }),
                        React.createElement("col", { style: { "width": "84%" } })),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col" }, "\uC810\uC218"),
                            React.createElement("th", { scope: "col" }, "\uD3C9\uAC00\uAE30\uC900"))),
                    React.createElement("tbody", null, (spgCheckItem) && spgCheckItem.filter(citem => citem.language === selLang).map((checkItem, idx) => (checkItem.checkItemRefDtoList.map((citem, idx) => (React.createElement("tr", { key: `tr_${idx.toString()}` },
                        React.createElement("td", null,
                            React.createElement("p", null, citem.score)),
                        React.createElement("td", null,
                            React.createElement("p", { className: "txt-left" }, citem.reference))))))))))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-open btn-close", "data-pop": "pop-spgcheck-edit", onClick: (e) => onClickUpdateSpgCheck(e, checkInfo) },
                React.createElement("span", null, "\uC218\uC815")),
            React.createElement("button", { type: "button", className: "", onClick: (e) => onClickCancel(e) },
                React.createElement("span", null, "\uD655\uC778")))));
}
// SPG 체크 항목 조회 
function PopupSpgCheckUpdate(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props
    const checkInfo = props.checkInfo;
    const workMode = props.workMode;
    const setParentWorkMode = props.setWorkMode;
    const setParentPopWin = props.setPopWin;
    const setParentListReload = props.setListReload;
    const updateCount = props.updateCount;
    const setParentUpdateCount = props.setUpdateCount;
    //
    const [spgCheckItem, setSpgCheckItem] = useState(null);
    const [errorList, setErrorList] = useState([]);
    //const onClickUpdateCheckMessage = props.onClickUpdateCheckMessage;
    const defaultRefDtoList = [
        { "score": 0, "reference": "" },
        { "score": 1, "reference": "" },
        { "score": 2, "reference": "" },
        { "score": 3, "reference": "" },
        { "score": 4, "reference": "" },
    ];
    clog("SPG CHECK UPDATE : INIT : " + workMode + " : " + updateCount);
    useEffect(() => {
        setSpgCheckItem(props.spgCheckItem);
    }, [updateCount, props.spgCheckItem]);
    function onClickCancel(e) {
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-spgcheck-detail");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "797");
        CUTIL.jsclose_Popup("pop-spgcheck-edit");
        //setParentWorkMode("READ");
        setParentUpdateCount(updateCount + 1);
        CUTIL.jsopen_Popup(e);
        setErrorList([]);
    }
    const [selLang, setSelLang] = useState(CONST.STR_APILANG_KOR);
    const langSet = [
        { "tabId": 0, "tabTxt": "한국어", "tabVal": CONST.STR_APILANG_KOR },
        { "tabId": 1, "tabTxt": "English", "tabVal": CONST.STR_APILANG_ENG },
        { "tabId": 2, "tabTxt": "中文", "tabVal": CONST.STR_APILANG_CHA },
    ];
    useEffect(() => {
        //setSpgCheckItem(null);//null
        setSelLang(CONST.STR_APILANG_KOR);
    }, []);
    function onClickLangTab(e) {
        var actTag = (e.target.tagName === "LI") ? e.target : e.currentTarget;
        var tabStrInfo = actTag.getAttribute("data-value");
        var tabInfo = JSON.parse(tabStrInfo);
        setSelLang(tabInfo.tabVal);
    }
    function setSpgCheckItemItemName(e) {
        setSpgCheckItem(spgCheckItem.map((fcheck) => ((fcheck.language === selLang) ? Object.assign(Object.assign({}, fcheck), { "checkItemName": e.target.value }) : fcheck)));
    }
    function setSpgCheckItemDescription(e) {
        setSpgCheckItem(spgCheckItem.map((fcheck) => ((fcheck.language === selLang) ? Object.assign(Object.assign({}, fcheck), { "description": e.target.value }) : fcheck)));
    }
    function setSpgCheckItemWeight(e) {
        setSpgCheckItem(spgCheckItem.map((fcheck) => ((fcheck.language === selLang) ? Object.assign(Object.assign({}, fcheck), { "weight": e.target.value }) : fcheck)));
    }
    function setSpgcheckItemRefDtoList(e, ridx) {
        setSpgCheckItem(spgCheckItem.map((fcheck) => ((fcheck.language === selLang)
            ? Object.assign(Object.assign({}, fcheck), { "checkItemRefDtoList": fcheck.checkItemRefDtoList.map((ref, idx) => ((ridx === idx) ? Object.assign(Object.assign({}, ref), { "reference": e.target.value }) : ref)) }) : fcheck)));
    }
    function onClickDoUpdateSpgCheck(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const errList = [];
            var doCnt = 0;
            var doneCnt = 0;
            var succCnt = 0;
            var isOk = confirm(`내용을 저장하시겠습니까?`);
            if (!isOk)
                return;
            let data = null;
            setRecoilIsLoadingBox(true);
            spgCheckItem.map((fcheck, idx) => __awaiter(this, void 0, void 0, function* () {
                CUTIL.sleep(500);
                //clog("UPDATE SPG CHECK : " + idx + " : " + JSON.stringify(fcheck));
                doCnt++;
                data = yield HTTPUTIL.PromiseHttp({
                    "httpMethod": "PUT",
                    "appPath": `/api/v2/checksheet/step/spg/item`,
                    appQuery: {
                        "code": fcheck.code,
                        "language": fcheck.language,
                        "name": fcheck.checkItemName,
                        "description": fcheck.description,
                        "weight": fcheck.weight,
                        "checkItemRefDtoList": fcheck.checkItemRefDtoList,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    doneCnt++;
                    if (data.codeNum == CONST.API_200) {
                        succCnt++;
                    }
                    else {
                        data.body.errorList.map((elist) => (errList.push({ "field": elist.field + fcheck.language, "msg": elist.msg })));
                    }
                }
                if (doneCnt === 3) { // KOR/ENG/CHA
                    setErrorList(errList);
                    setParentListReload(true, -1); // only list reload & page reset done
                    setParentWorkMode("READ");
                    setParentUpdateCount(updateCount + 1);
                    setParentPopWin("pop-spgcheck-detail", //pop-spgcheck-detail
                    React.createElement(PopupSpgCheckView, { htmlHeader: React.createElement("h1", null, "\uB2E4\uAD6D\uC5B4 \uAD00\uB9AC"), checkInfo: checkInfo, setListReload: props.setListReload, workMode: "READ", setWorkMode: props.setWorkMode, setPopWin: props.setPopWin }));
                    if (doCnt === succCnt) {
                        CUTIL.jsclose_Popup("pop-spgcheck-edit");
                        var popupVal = e.target.getAttribute("data-pop");
                        if (CUTIL.isnull(popupVal))
                            e.target.setAttribute("data-pop", "pop-spgcheck-detail");
                        CUTIL.jsopen_Popup(e);
                    }
                    else {
                    }
                    doneCnt = 0;
                    setRecoilIsLoadingBox(false);
                }
            }));
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            (spgCheckItem) && spgCheckItem.filter(citem => citem.language === selLang).map((checkItem, idx) => (React.createElement(React.Fragment, { key: `rfr_${idx.toString()}` },
                React.createElement("ul", { className: "form__input" },
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC810\uAC80\uB2E8\uACC4"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", value: (checkItem.language === selLang) ? checkItem.checkStepDto.name : "", disabled: true }))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uAE30\uAE30 \uBA85"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", value: (checkItem.language === selLang) ? checkItem.spgDto.name : "", disabled: true }))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uADF8\uB8F9 \uBA85"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", value: (checkItem.language === selLang) ? checkItem.checkGroupDto.groupName : "", disabled: true })))),
                React.createElement("ul", { className: "tab__small" }, langSet.map((tlang, idx) => (React.createElement("li", { key: `tli_${idx.toString()}`, className: (tlang.tabVal === selLang) ? "on" : "", onClick: (e) => onClickLangTab(e), "data-value": JSON.stringify(tlang) },
                    React.createElement("a", null, tlang.tabTxt))))),
                React.createElement("ul", { className: "form__input" },
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC774\uB984"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", className: (errorList.filter(err => (err.field === "name" + checkItem.language)).length > 0) ? "input-error" : "", value: (checkItem.language === selLang) ? (!CUTIL.isnull(checkItem.checkItemName)) ? checkItem.checkItemName : "" : "", onChange: (e) => setSpgCheckItemItemName(e) }),
                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "name" + checkItem.language)).map((err) => err.msg)))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC124\uBA85"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", className: (errorList.filter(err => (err.field === "description" + checkItem.language)).length > 0) ? "input-error" : "", value: (checkItem.language === selLang) ? (!CUTIL.isnull(checkItem.description)) ? checkItem.description : "" : "", onChange: (e) => setSpgCheckItemDescription(e) }),
                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "description" + checkItem.language)).map((err) => err.msg)))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uAC00\uC911\uCE58"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", className: (errorList.filter(err => (err.field === "weight" + checkItem.language)).length > 0) ? "input-error" : "", value: (checkItem.language === selLang) ? (!CUTIL.isnull(checkItem.weight)) ? checkItem.weight : "" : "", onChange: (e) => setSpgCheckItemWeight(e) }),
                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "weight" + checkItem.language)).map((err) => err.msg)))))))),
            React.createElement("div", { className: "tbl-list" },
                React.createElement("table", { summary: "\uC810\uC218, \uD3C9\uAC00\uAE30\uC900 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uD310\uC815 List \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "\uD310\uC815 List"),
                    React.createElement("colgroup", null,
                        React.createElement("col", { style: { "width": "16%" } }),
                        React.createElement("col", { style: { "width": "84%" } })),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col" }, "\uC810\uC218"),
                            React.createElement("th", { scope: "col" }, "\uD3C9\uAC00\uAE30\uC900"))),
                    React.createElement("tbody", null, (spgCheckItem) && spgCheckItem.filter(citem => citem.language === selLang).map((checkItem, idx) => (checkItem.checkItemRefDtoList.map((citem, ridx) => (React.createElement("tr", { key: `tr_${ridx.toString()}` },
                        React.createElement("td", null,
                            React.createElement("p", null, citem.score)),
                        React.createElement("td", null,
                            React.createElement("div", { className: "input__area" },
                                React.createElement("textarea", { value: citem.reference, onChange: (e) => setSpgcheckItemRefDtoList(e, ridx) })))))))))))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-close", onClick: (e) => onClickCancel(e) },
                React.createElement("span", null, "\uCDE8\uC18C")),
            React.createElement("button", { type: "button", className: "js-open", "data-pop": "pop-spgcheck-detail", onClick: (e) => onClickDoUpdateSpgCheck(e) },
                React.createElement("span", null, "\uC800\uC7A5")))));
}
// SPG 체크 항목 등록
function PopupSpgCheckInsert(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    const [langs, setRecoilLangs] = useRecoilState(langState); // recoil langState
    //props
    const spgInfo = props.spgInfo;
    const setParentListReload = props.setListReload;
    const insertCount = props.insertCount;
    const setParentInsertCount = props.setInsertCount;
    /*
    const workMode = props.workMode;
    const setParentWorkMode = props.setWorkMode;
    const setParentPopWin = props.setPopWin;
    const updateCount = props.updateCount;
    const setParentUpdateCount = props.setUpdateCount;
    */
    //
    const defaultRefDtoList = [
        { "score": 0, "reference": "" },
        { "score": 1, "reference": "" },
        { "score": 2, "reference": "" },
        { "score": 3, "reference": "" },
        { "score": 4, "reference": "" },
    ];
    //clog("INSERT : SPG INFO : " + JSON.stringify(spgInfo) + " : " + JSON.stringify(langs));
    const stepList = [
        { "stepName": "Basic", "stepVal": "BASIC" },
        { "stepName": "Advanced", "stepVal": "ADVANCED" },
        { "stepName": "Premium", "stepVal": "PREMIUM" },
    ];
    const [selStep, setSelStep] = useState(stepList[0]);
    const [spgCheckGroup, setSpgCheckGroup] = useState(null);
    const [selGroup, setSelGroup] = useState(null);
    const [errorList, setErrorList] = useState([]);
    const defaultCheckItem = {
        "versionNo": spgInfo.versionNo,
        "spgName": spgInfo.spgName,
        "stepName": stepList[0].stepVal,
        "checkGroupName": "",
        "name": "",
        "weight": 0,
        "language": CONST.STR_APILANG_KOR,
        "description": "",
        "checkItemRefDtoList": defaultRefDtoList,
    };
    const [spgCheckItem, setSpgCheckItem] = useState([defaultCheckItem,]);
    useEffect(() => {
        setSpgCheckItem([defaultCheckItem,]);
        setSelStep(stepList[0]);
        setSpgCheckGroup(null);
    }, [insertCount, spgInfo]);
    clog("INSER : INIT : SELSTEP : " + JSON.stringify(selStep));
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/checksheet/step/spg/checkgroups?spgName=${spgInfo.spgName}&stepName=${selStep.stepVal}`,
        appQuery: {
            language: CUTIL.apiLangSet(langs)
        },
        userToken: userInfo.loginInfo.token,
        watch: spgInfo + selStep.stepVal + insertCount
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        if (retData) {
            setRecoilIsLoadingBox(false);
            clog("IN SPGCHECK INSERT GROUP : RES : " + JSON.stringify(retData.body));
            if (retData.codeNum == CONST.API_200) {
                //setSelGroup(retData.body[0]);
                setSpgCheckItem(spgCheckItem.map((fcheck) => ((fcheck.language === selLang) ? Object.assign(Object.assign({}, fcheck), { "checkGroupName": retData.body[0].groupName }) : fcheck)));
                setSpgCheckGroup(retData.body);
            }
        }
    }, [retData]);
    /*
    clog("SPG CHECK UPDATE : INIT : " + workMode + " : " + updateCount);
    useEffect(()=>{
      setSpgCheckItem(props.spgCheckItem);
    }, [updateCount, props.spgCheckItem])
    */
    function onClickCancel(e) {
        //var popupVal = e.target.getAttribute("data-pop");
        //if (CUTIL.isnull(popupVal)) e.target.setAttribute("data-pop", "pop-spgcheck-detail");  
        CUTIL.jsclose_Popup("pop-spgcheck-add");
        //setParentWorkMode("READ");
        //setParentUpdateCount(updateCount+1);
        //CUTIL.jsopen_Popup(e);
        setParentInsertCount(insertCount + 1);
        setErrorList([]);
    }
    const [selLang, setSelLang] = useState(CONST.STR_APILANG_KOR);
    const langSet = [
        { "tabId": 0, "tabTxt": "한국어", "tabVal": CONST.STR_APILANG_KOR },
        { "tabId": 1, "tabTxt": "English", "tabVal": CONST.STR_APILANG_ENG },
        { "tabId": 2, "tabTxt": "中文", "tabVal": CONST.STR_APILANG_CHA },
    ];
    useEffect(() => {
        //setSpgCheckItem(null);//null
        setSelLang(CONST.STR_APILANG_KOR);
    }, []);
    function selectOptionGroup(optionElement) {
        const selectBox = optionElement.closest(".select");
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        var optionData = optionElement.getAttribute("data-value");
        selectedElement.setAttribute("data-value", optionData);
        //
        //setSelGroup(JSON.parse(optionData))
        setSpgCheckItem(spgCheckItem.map((fcheck) => ((fcheck.language === selLang) ? Object.assign(Object.assign({}, fcheck), { "checkGroupName": JSON.parse(optionData).groupName }) : fcheck)));
        // params init
    }
    function selectOptionStep(optionElement) {
        const selectBox = optionElement.closest(".select");
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        var optionData = optionElement.getAttribute("data-value");
        selectedElement.setAttribute("data-value", optionData);
        //
        setSelStep(JSON.parse(optionData));
        /*setSpgCheckItem(spgCheckItem.map((fcheck)=>(
          (fcheck.language===selLang)?{...fcheck, "stepName" : JSON.parse(optionData).groupName}:fcheck)
        ))*/
        // params init
    }
    function onClickLangTab(e) {
        var actTag = (e.target.tagName === "LI") ? e.target : e.currentTarget;
        var tabStrInfo = actTag.getAttribute("data-value");
        var tabInfo = JSON.parse(tabStrInfo);
        setSelLang(tabInfo.tabVal);
    }
    function setSpgCheckItemItemName(e) {
        setSpgCheckItem(spgCheckItem.map((fcheck) => ((fcheck.language === selLang) ? Object.assign(Object.assign({}, fcheck), { "name": e.target.value }) : fcheck)));
    }
    function setSpgCheckItemDescription(e) {
        setSpgCheckItem(spgCheckItem.map((fcheck) => ((fcheck.language === selLang) ? Object.assign(Object.assign({}, fcheck), { "description": e.target.value }) : fcheck)));
    }
    function setSpgCheckItemWeight(e) {
        setSpgCheckItem(spgCheckItem.map((fcheck) => ((fcheck.language === selLang) ? Object.assign(Object.assign({}, fcheck), { "weight": e.target.value }) : fcheck)));
    }
    function setSpgcheckItemRefDtoList(e, ridx) {
        setSpgCheckItem(spgCheckItem.map((fcheck) => ((fcheck.language === selLang)
            ? Object.assign(Object.assign({}, fcheck), { "checkItemRefDtoList": fcheck.checkItemRefDtoList.map((ref, idx) => ((ridx === idx) ? Object.assign(Object.assign({}, ref), { "reference": e.target.value }) : ref)) }) : fcheck)));
    }
    function onClickDoInsertSpgCheck(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const errList = [];
            var doCnt = 0;
            var doneCnt = 0;
            var succCnt = 0;
            var isOk = confirm(`내용을 저장하시겠습니까?`);
            if (!isOk)
                return;
            let data = null;
            setRecoilIsLoadingBox(true);
            spgCheckItem.filter((fcheck) => fcheck.language === CONST.STR_APILANG_KOR).map((fcheck, idx) => __awaiter(this, void 0, void 0, function* () {
                //CUTIL.sleep(500);
                clog("InSERT SPG CHECK : " + idx + " : " + JSON.stringify(fcheck));
                doCnt++;
                data = yield HTTPUTIL.PromiseHttp({
                    "httpMethod": "POST",
                    "appPath": `/api/v2/checksheet/step/spg/item`,
                    appQuery: {
                        "versionNo": fcheck.versionNo,
                        "spgName": fcheck.spgName,
                        "stepName": selStep.stepVal,
                        "checkGroupName": fcheck.checkGroupName,
                        "name": fcheck.name,
                        "description": fcheck.description,
                        "language": fcheck.language,
                        "weight": fcheck.weight,
                        "checkItemRefDtoList": fcheck.checkItemRefDtoList
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    doneCnt++;
                    if (data.codeNum == CONST.API_200) {
                        succCnt++;
                    }
                    else {
                        data.body.errorList.map((elist) => (errList.push({ "field": elist.field + fcheck.language, "msg": elist.msg })));
                    }
                }
                if (doneCnt === 1) { // KOR/ENG/CHA
                    setErrorList(errList);
                    setParentListReload(true, 0); // only list reload & page reset done
                    setParentInsertCount(insertCount + 1);
                    /*setParentWorkMode("READ");
                    setParentPopWin("pop-spgcheck-detail", //pop-spgcheck-detail
                      <PopupSpgCheckView
                        htmlHeader={<h1>다국어 관리</h1>}
                        checkInfo={checkInfo}
                        listReload={listReload}
                        setListReload={props.setListReload} // list reload
                        workMode={"READ"}
                        setWorkMode={props.setWorkMode}
                        setPopWin={props.setPopWin}
                      />
                    );*/
                    if (doCnt === succCnt) {
                        CUTIL.jsclose_Popup("pop-spgcheck-add");
                        /*
                        var popupVal = e.target.getAttribute("data-pop");
                        if (CUTIL.isnull(popupVal)) e.target.setAttribute("data-pop", "pop-spgcheck-detail");
                        CUTIL.jsopen_Popup(e);
                        */
                    }
                    else {
                    }
                    doneCnt = 0;
                    setRecoilIsLoadingBox(false);
                }
            }));
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            (spgCheckItem) && spgCheckItem.filter(citem => citem.language === selLang).map((checkItem, idx) => (React.createElement(React.Fragment, { key: `rfr_${idx.toString()}` },
                React.createElement("ul", { className: "form__input" },
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC810\uAC80\uB2E8\uACC4"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("div", { className: "select", onClick: (e) => CUTIL.onClickSelect(e, selectOptionStep) },
                                React.createElement("div", { className: "selected" },
                                    React.createElement("div", { className: "selected-value" }, selStep.stepName),
                                    React.createElement("div", { className: "arrow" })),
                                React.createElement("ul", null, stepList.map((step, idx) => (React.createElement("li", { key: `li_${idx.toString()}`, className: "option", "data-value": JSON.stringify(step) }, step.stepName))))),
                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "stepName" + checkItem.language)).map((err) => err.msg)))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uAE30\uAE30 \uBA85"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", value: (checkItem.language === selLang) ? checkItem.spgName : "", disabled: true }))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uADF8\uB8F9 \uBA85"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("div", { className: "select", onClick: (e) => CUTIL.onClickSelect(e, selectOptionGroup) },
                                React.createElement("div", { className: "selected" },
                                    React.createElement("div", { className: "selected-value" }, spgCheckGroup && spgCheckGroup[0].groupName),
                                    React.createElement("div", { className: "arrow" })),
                                React.createElement("ul", null, (spgCheckGroup) && spgCheckGroup.map((cgroup, idx) => (React.createElement("li", { key: `li_${idx.toString()}`, className: "option", "data-value": JSON.stringify(cgroup) }, cgroup.groupName))))),
                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "checkGroupName" + checkItem.language)).map((err) => err.msg))))),
                React.createElement("ul", { className: "tab__small" }, langSet.map((tlang, idx) => (React.createElement("li", { key: `tli_${idx.toString()}`, className: (tlang.tabVal === selLang) ? "on" : "", onClick: (e) => (tlang.tabVal === CONST.STR_APILANG_KOR) && onClickLangTab(e), "data-value": JSON.stringify(tlang) },
                    React.createElement("a", null, tlang.tabTxt))))),
                React.createElement("ul", { className: "form__input" },
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC774\uB984"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", className: (errorList.filter(err => (err.field === "name" + checkItem.language)).length > 0) ? "input-error" : "", value: (checkItem.language === selLang) ? (!CUTIL.isnull(checkItem.name)) ? checkItem.name : "" : "", onChange: (e) => setSpgCheckItemItemName(e) }),
                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "name" + checkItem.language)).map((err) => err.msg)))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC124\uBA85"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", className: (errorList.filter(err => (err.field === "description" + checkItem.language)).length > 0) ? "input-error" : "", value: (checkItem.language === selLang) ? (!CUTIL.isnull(checkItem.description)) ? checkItem.description : "" : "", onChange: (e) => setSpgCheckItemDescription(e) }),
                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "description" + checkItem.language)).map((err) => err.msg)))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uAC00\uC911\uCE58"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", className: (errorList.filter(err => (err.field === "weight" + checkItem.language)).length > 0) ? "input-error" : "", value: (checkItem.language === selLang) ? (!CUTIL.isnull(checkItem.weight)) ? checkItem.weight : "" : "", onChange: (e) => setSpgCheckItemWeight(e) }),
                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "weight" + checkItem.language)).map((err) => err.msg)))))))),
            React.createElement("div", { className: "tbl-list" },
                React.createElement("table", { summary: "\uC810\uC218, \uD3C9\uAC00\uAE30\uC900 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uD310\uC815 List \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "\uD310\uC815 List"),
                    React.createElement("colgroup", null,
                        React.createElement("col", { style: { "width": "16%" } }),
                        React.createElement("col", { style: { "width": "84%" } })),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col" }, "\uC810\uC218"),
                            React.createElement("th", { scope: "col" }, "\uD3C9\uAC00\uAE30\uC900"))),
                    React.createElement("tbody", null, (spgCheckItem) && spgCheckItem.filter(citem => citem.language === selLang).map((checkItem, idx) => (checkItem.checkItemRefDtoList.map((citem, ridx) => (React.createElement("tr", { key: `tr_${ridx.toString()}` },
                        React.createElement("td", null,
                            React.createElement("p", null, citem.score)),
                        React.createElement("td", null,
                            React.createElement("div", { className: "input__area" },
                                React.createElement("textarea", { value: citem.reference, onChange: (e) => setSpgcheckItemRefDtoList(e, ridx) })))))))))))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-close", onClick: (e) => onClickCancel(e) },
                React.createElement("span", null, "\uCDE8\uC18C")),
            React.createElement("button", { type: "button", className: "js-open", "data-pop": "pop-spgcheck-", onClick: (e) => onClickDoInsertSpgCheck(e) },
                React.createElement("span", null, "\uC800\uC7A5")))));
}
